import { useClientInvoices } from '../../../entities/client-invoices-list/lib/client-invoices-list.hook';
import { usePagingParams } from '../../../shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';
import { InvoicesList } from '../../../entities/invoice/list';
import { useStateSelector } from '../../../shared/store';

export const CloseInvoices = () => {
  const [paging, setPaging] = usePagingParams();

  const [searchParams] = useSearchParams();

  const selectedPeriod = useStateSelector((state) => state.salaryPageSelectedPeriod.value);

  const params = new URLSearchParams();
  const manager = searchParams.get('manager');
  const statusIds = searchParams.get('statusIds');
  if (manager) params.set('managerId', manager);
  if (statusIds) params.set('statusIds', statusIds);
  params.set('closingYear', String(selectedPeriod.year));
  params.set('closingMonth', String(selectedPeriod.month));

  const { collection } = useClientInvoices(paging, params.toString());

  return <InvoicesList collection={collection} onChangePaging={setPaging} paging={paging} withSalaryEntries />;
};
